import { StoreState } from './app.reducers';
import { Column } from '../models/api/api.models';
import { Undefineable } from '../models/Undefineable';

export const getOrderedColumns = (state: StoreState): Undefineable<Column[]> =>
  state.board?.board?.columns?.concat().sort((a, b) =>
    a?.order === undefined || b?.order === undefined ? 0 : a.order - b.order);